export var unableToReply = function unableToReply(message) {
  return {
    severity: 'error',
    message: message || 'Sorry, we are unable to post your reply',
    duration: 'medium'
  };
};
export var unableToEdit = function unableToEdit(message) {
  return {
    severity: 'error',
    message: message || 'Sorry, we are unable to edit your comment',
    duration: 'medium'
  };
};
export var unableToDelete = function unableToDelete(message) {
  return {
    severity: 'error',
    message: message || 'Sorry, we are unable to delete this comment',
    duration: 'medium'
  };
};